import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=6b737e62&scoped=true"
import script from "./Scrollbar.vue?vue&type=script&lang=js"
export * from "./Scrollbar.vue?vue&type=script&lang=js"
import style0 from "./Scrollbar.vue?vue&type=style&index=0&id=6b737e62&prod&lang=scss"
import style1 from "./Scrollbar.vue?vue&type=style&index=1&id=6b737e62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b737e62",
  null
  
)

export default component.exports